import type { ApiResponse } from '../services/api';
import type { ToastApi } from '../components/ToastProvider';

export function notifyApiResult<T>(
  toast: ToastApi,
  res: ApiResponse<T>,
  successMessage: string | ((data: T) => string),
): res is ApiResponse<T> & { data: T } {
  if (res.data) {
    const message =
      typeof successMessage === 'function' ? successMessage(res.data) : successMessage;
    toast.success(message);
    return true;
  }
  if (res.error) {
    toast.error(res.error.message);
  }
  return false;
}
